import type { FC } from 'react';

import {
  TeamMembersRequest,
  TeamMembersRequestStatus,
} from '__generated__/GQL';
import SunshineTag, { SunshineTagProps } from 'components/_core/SunshineTag';

import locales from './locales';

type TeamMembersRequestStatusFrom = 'account-holder' | 'managed-user';

interface TeamMemberRequestStatusBadgeProps extends SunshineTagProps {
  request: Pick<TeamMembersRequest, 'status' | 'type'>;
  from: TeamMembersRequestStatusFrom;
}

const TAG_COLOR_SCHEME_MAP = {
  'account-holder': {
    [TeamMembersRequestStatus.Pending]: 'blue',
    [TeamMembersRequestStatus.Approved]: 'yellow',
    [TeamMembersRequestStatus.Completed]: 'green',
    [TeamMembersRequestStatus.Rejected]: 'red',
    [TeamMembersRequestStatus.Canceled]: 'red',
    [TeamMembersRequestStatus.Processed]: 'yellow',
  },
  'managed-user': {
    [TeamMembersRequestStatus.Pending]: 'grey',
    [TeamMembersRequestStatus.Approved]: 'grey',
    [TeamMembersRequestStatus.Completed]: 'green',
    [TeamMembersRequestStatus.Rejected]: 'red',
    [TeamMembersRequestStatus.Canceled]: 'red',
    [TeamMembersRequestStatus.Processed]: 'grey',
  },
} satisfies Record<
  TeamMembersRequestStatusFrom,
  Record<TeamMembersRequestStatus, SunshineTagProps['colorScheme']>
>;

export const TeamMemberRequestStatusBadge: FC<
  TeamMemberRequestStatusBadgeProps
> = ({ from, request, ...props }) => {
  return (
    <SunshineTag
      colorScheme={TAG_COLOR_SCHEME_MAP[from][request.status]}
      noOfLines={1}
      size="sm"
      {...props}
    >
      {locales[request.type].status[request.status]}
    </SunshineTag>
  );
};
